/**
 * Convert a native storage failure into a user-facing message.
 *
 * This helper does not mutate the native exception or any stored data.
 */
export function audioCacheErrorText(error: unknown): string {
  const name = typeof error === 'object' && error !== null && 'name' in error
    ? String((error as { name?: unknown }).name || '')
    : '';
  if (name === 'SecurityError') {
    return '浏览器阻止了音频缓存访问（安全策略错误）。请检查此网站的存储权限后重新读取。';
  }
  if (name === 'QuotaExceededError') {
    return '浏览器存储空间不足（存储空间错误）。请释放浏览器存储空间后重新读取。';
  }
  return '暂时无法读取音频缓存（未知存储错误）。请重新读取，若仍然失败请稍后再试。';
}
